export default __webpack_public_path__ + "static/class-de44dac28297767834959434dfb863ab.jpg";